import React, { Component } from 'react';
import FullReportPrimaryComponent from "./full-report-primary-or-sentiment-component";
import {connect} from "react-redux";
import {searchChange} from "./full-report-primary-or-sentiment-action-creators";


class FullReportPrimaryContainer extends Component {


  render() {
    return <FullReportPrimaryComponent {...this.props} />
  }
}



const mapStateToProps = (state, ownProps) => ({
  primaryEmotions: state.fullReportPrimaryOrSentiment.primaryEmotionsBreakdownProcessed,
  sentimentBreakdown: state.fullReportPrimaryOrSentiment.sentimentBreakdownProcessed,
  primary: ownProps.primary,
  primarySearchValue: state.fullReportPrimaryOrSentiment.primarySearchValue,
  sentimentSearchValue: state.fullReportPrimaryOrSentiment.sentimentSearchValue
});


const mapDispatchToProps = dispatch => ({
  searchChange: ({ searchValue, primary }) => dispatch(searchChange({ searchValue, primary }))
});


export default connect(mapStateToProps, mapDispatchToProps)(FullReportPrimaryContainer);




// WEBPACK FOOTER //
// ./src/modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-container.js